export type EntityUrlBuilders = {
  productDetailsUrl: (id?: string) => string;
  skuDetailsUrl: (id?: string) => string;
  qualificationDetailsUrl: (id?: string) => string;
  evaluationDetailsUrl: (id?: string) => string;
  certificateDetailsUrl: (id?: string) => string;
  userDetailsUrl: (id?: string) => string;
};

const GENERATED_ID_PATTERN = /GeneratedId:\s*'([0-9a-fA-F-]{36})'/;

export function containsGeneratedId(message?: string): boolean {
  return !!message && GENERATED_ID_PATTERN.test(message);
}

/** Pulls the created entity's id out of the free-text message the downstream handler writes back. */
export function parseGeneratedId(messages?: (string | undefined)[]): string | undefined {
  for (const message of messages ?? []) {
    const match = message?.match(GENERATED_ID_PATTERN);

    if (match) {
      return match[1];
    }
  }

  return undefined;
}

type UrlBuilder = (urls: EntityUrlBuilders, id: string) => string;

/**
 * Entity types that have a KAdmin detail page, keyed on the JobDataType name. Anything absent renders
 * as plain text: linking a type to a route that does not exist is worse than not linking it.
 */
const detailUrlByType: Record<string, UrlBuilder> = {
  Product: (urls, id) => urls.productDetailsUrl(id),
  Sku: (urls, id) => urls.skuDetailsUrl(id),
  Qualification: (urls, id) => urls.qualificationDetailsUrl(id),
  Evaluation: (urls, id) => urls.evaluationDetailsUrl(id),
  UserCertificate: (urls, id) => urls.certificateDetailsUrl(id),
  User: (urls, id) => urls.userDetailsUrl(id),
  OrganizationUser: (urls, id) => urls.userDetailsUrl(id),
};

export function entityDetailUrl(
  urls: EntityUrlBuilders,
  jobDataType?: string,
  generatedId?: string
): string | undefined {
  if (!jobDataType || !generatedId) {
    return undefined;
  }

  return detailUrlByType[jobDataType]?.(urls, generatedId);
}
